/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  LessonPlanMaterialGeneration,
  LessonPlanPhaseMaterialInput,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Generate material for lesson plan phase
 */
export const createLessonPlanPhaseMaterial = (
    phaseId: MaybeRefOrGetter<string>,
    lessonPlanPhaseMaterialInput: MaybeRefOrGetter<LessonPlanPhaseMaterialInput>,
 signal?: AbortSignal
) => {
      phaseId = toValue(phaseId);
lessonPlanPhaseMaterialInput = toValue(lessonPlanPhaseMaterialInput);

      return axiosClient<LessonPlanMaterialGeneration>(
      {url: `/lesson_plan/phases/${phaseId}/materials`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: lessonPlanPhaseMaterialInput, signal
    },
      );
    }




export const getCreateLessonPlanPhaseMaterialMutationKey = () => ['createLessonPlanPhaseMaterial'] as const;

export const getCreateLessonPlanPhaseMaterialMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLessonPlanPhaseMaterial>>, TError,CreateLessonPlanPhaseMaterialMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createLessonPlanPhaseMaterial>>, TError,CreateLessonPlanPhaseMaterialMutationVariables, TContext> => {

const mutationKey = getCreateLessonPlanPhaseMaterialMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLessonPlanPhaseMaterial>>, CreateLessonPlanPhaseMaterialMutationVariables> = (props) => {
          const {phaseId,data} = props ?? {};

          return  createLessonPlanPhaseMaterial(phaseId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLessonPlanPhaseMaterialMutationResult = NonNullable<Awaited<ReturnType<typeof createLessonPlanPhaseMaterial>>>
    export type CreateLessonPlanPhaseMaterialMutationBody = LessonPlanPhaseMaterialInput
    export type CreateLessonPlanPhaseMaterialMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CreateLessonPlanPhaseMaterialMutationVariables = {phaseId: string;data: LessonPlanPhaseMaterialInput}

    /**
 * @summary Generate material for lesson plan phase
 */
export const useCreateLessonPlanPhaseMaterial = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLessonPlanPhaseMaterial>>, TError,CreateLessonPlanPhaseMaterialMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createLessonPlanPhaseMaterial>>,
        TError,
        CreateLessonPlanPhaseMaterialMutationVariables,
        TContext
      > => {
      return useMutation(getCreateLessonPlanPhaseMaterialMutationOptions(options), queryClient);
    }
